import React from 'react'

import { Button, Col, Table, Row } from '_zari/core'

import { OrigenesContabilidadConstant } from 'constants/index'

import * as Modals from './modals'

import RowTemplate from './rowTemplate'

const tableHeaderRows = [
  { label: 'PRODUCTO' },
  { label: 'TIPO' },
  { label: 'CUENTA CONTABLE' },
  { label: 'CENTRO COSTO 1', width: 170 },
  { label: 'CENTRO COSTO 2', width: 170 },
  { label: 'DESTINO', width: 170 },
  { label: 'MONEDA', width: 100 },
  { label: 'DEBE', width: 90 },
  { label: 'HABER', width: 90 },
  { label: '', width: 50 },
  { label: '', width: 30 }
]

const DetalleTablaSection = ({ setDiferenciaSoles, vTipoCambio, vOrigen, vGlosa, vIdGlosa, detalles, dispatch, setFieldValue }) => {
  const [mostrarEntregaARendirModal, setMostrarEntregaARendirModal] = React.useState(false)

  const updateStatus = React.useCallback(
    payload => {
      setDiferenciaSoles(0)
      dispatch({ type: 'actualizar', payload: payload })
    },
    [dispatch, setDiferenciaSoles]
  )

  const clickAgregarFila = React.useCallback(() => {
    dispatch({
      type: 'agregar',
      payload: { tipoCambio: vTipoCambio, glosa: vGlosa, _idGlosa: vIdGlosa }
    })
  }, [dispatch, vTipoCambio, vGlosa, vIdGlosa])

  const handleEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const clickEntregasARendir = React.useCallback(() => {
    setMostrarEntregaARendirModal(true)
  }, [])

  return (
    <>
      <Row className='mb-2'>
        <Col md={6}>
          <Button id='button-agregarFila' onClick={clickAgregarFila} tiny>
            Agregar Fila
          </Button>
        </Col>
        {vOrigen === OrigenesContabilidadConstant.CAJA_EGRESOS || vOrigen === OrigenesContabilidadConstant.BANCOS ? (
          <Col md={6} className='text-right'>
            <Button onClick={clickEntregasARendir} tiny outline>
              Entregas a rendir
            </Button>
          </Col>
        ) : null}
      </Row>
      <Table
        containerId='container-detallesnuevoasiento'
        filas={detalles}
        headRows={tableHeaderRows}
        rowTemplate={(row, k) => (
          <RowTemplate
            key={row._idFila}
            row={row}
            rowIndex={k}
            updateStatus={updateStatus}
            handleEliminar={handleEliminar}
            handleAgregarFila={clickAgregarFila}
            esUltimaFila={k === detalles.length - 1}
          />
        )}
      />
      {mostrarEntregaARendirModal && (
        <Modals.EntregaARendirModal
          show={mostrarEntregaARendirModal}
          handleClose={() => setMostrarEntregaARendirModal(false)}
          dispatch={dispatch}
          vTipoCambio={vTipoCambio}
          setFieldValue={setFieldValue}
        />
      )}
    </>
  )
}

export default React.memo(DetalleTablaSection)
